import Handler from '@/core/domain/usecase/handler';

const getEquipmentHistoryRepository = (axios) => async (id) => {
    try {
        const response = await axios.get(`equipment-history/${id}`)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default getEquipmentHistoryRepository